import React from "react";
import "./index.less";

// fixed 是否固定当前盒子所占据的空间

const ActiveBtn = ({ onClick, children, icon, show, fixed = false }) => {
  let styleConfig = {
    right: show ? "2vw" : "-40vw",
  };

  if (!fixed) {
    styleConfig = {
      ...styleConfig,
      height: show ? "10vw" : "0vw",
      width: show ? "12vw" : "0vw",
      padding: show ? "1.6vw" : "0vw",
      border: show ? "1px solid #c9c9c92a" : "none",
      marginBottom: show ? "2vw" : "0px",
    };
  }

  return (
    <div className="activeBtn" style={styleConfig} onClick={onClick}>
      <img src={icon} style={{ width: "5vw", height: "5vw" }} alt="" />
      {children}
    </div>
  );
};

export default ActiveBtn;
